import ButtonComponent from "./ButtonComponent";
import { ErrorState } from "./ErrorState";

/**
 * Styled fallback for the top-level `Sentry.ErrorBoundary` in `main.tsx`.
 * Sentry reports the error and supplies `eventId` / `resetError`, so this only
 * renders the UI. Catches errors that escape the router's own boundary.
 */
export function AppErrorFallback({
  resetError,
  eventId,
}: {
  eventId?: string;
  resetError?: () => void;
}) {
  return (
    <ErrorState eventId={eventId}>
      <ButtonComponent onClick={() => resetError?.()}>Retry</ButtonComponent>
      <ButtonComponent variant="outline" onClick={() => window.location.assign("/")}>
        Return Home
      </ButtonComponent>
    </ErrorState>
  );
}
